<template lang="pug">
  modal(name="place" :min-height="500" :adaptive="true" :scrollable="true" width="925" height="auto" @closed="handleClose")
    .container
      .guide-modal(class="p-0 md:px-10 md:py-20")
        button.modal-exit--grey(@click.prevent="$modal.hide('place')")
          .fal.fa-times.h3

        .max-h-modal-mobile.overflow-auto.mt-32(class="xl:mt-0 md:max-h-modal xl:max-h-full")
          .p-8(class="md:px-24" v-if="place.id")
            .title--md.text-center.font-bold.mb-8(class="md:mt-0 md:pt-0") {{ place.attributes.title }}

            .slider-detail(v-if="place.attributes.pictures.length")
              agile(
                :autoplay="true"
                :speed="750"
                timing="ease-in-out"
                :dots="false"
                :nav-buttons="false"
                :pause-on-hover="false"
                :slides-to-show="1"
                :autoplay-speed="8000"
                :responsive=`[
                  {
                    breakpoint: 992,
                    settings: {
                      navButtons: true,
                      dots: true,
                      centerMode: true
                    }
                  }
                ]`
              )
                .slide(v-for="picture in place.attributes.pictures")
                  img(
                    :src="picture"
                  )

                template(slot="prevButton")
                  i.fal.fa-chevron-left

                template(slot="nextButton")
                  i.fal.fa-chevron-right
            .h4.font-medium.text-center.my-6.mx-20.p-2.leading-15(class="md:p-0 md:mx-0 md:mb-8 md:text-left lg:mt-0")
              | {{ place.attributes.address }}

            .block.mb-16(class="md:flex md:justify-between")
              .block(class="md:flex md:content-start md:justify-start")
                .text-secondary.h5.p-0.m-0.text-center(class="md:text-left md:pr-6 md:mt-1")
                  i.fas.fa-bus
                .h5.font-medium.leading-15.text-center(class="md:text-left" v-html="place.attributes.access_html")
              .block(v-if="place.attributes.opening_description" class="md:flex md:content-start md:justify-start")
                .text-secondary.h5.p-0.m-0.text-center(class="md:text-left md:pr-6 md:mt-1")
                  i.fas.fa-clock
                .h5.font-medium.leading-15.text-center(class="md:text-left", v-html="place.attributes.opening_description_html")
            .text-title.leading-15.h2.mb-6.text-secondary.text-center.text-3xl(class="md:text-4xl md:text-left") {{ place.attributes.description_title }}
            .wysiwyg-wrapper
              p.h4.font-medium.mb-16(v-html="place.attributes.description")
            .flex.justify-center.mb-4(class="md:justify-start")
              a(:href="`tel:${place.attributes.phone}`" class="btn btn-secondary mr-8 text-center flex items-center") {{ place.attributes.phone }}
              a(v-if="place.attributes.website_without_scheme" :href="place.attributes.website" class="btn btn-outline-secondary-whitebg border-2 w-full md:w-auto text-center", target="_blank", rel='noopener') {{ place.attributes.website_without_scheme }}
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true,
      default: () => ({})
    },

    translations: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    handleClose () {
      const url = new URL(window.location.href)
      const modalParams = new URLSearchParams(url.search)
      modalParams.delete('opened_modal_place_id')
      url.search = modalParams.toString()

      history.replaceState(null, null, url.toString())
      this.$eventBus.$emit('reset-opened-modal-place-id')
    }
  }
}
</script>
